import React from "react";
import PropTypes from "prop-types";
import "./index.css";
const LocationsComponent = ({
  location,
  clinicName,
  clinicAddress,
  clinicPhone,
  clinicHours,
}) => {
  return (
    <div className="location-info">
      <h2 className="locationTitle">{location}</h2>
      <div className="clinicName">
        <strong>{clinicName}</strong>
      </div>
      <div className="clinic-address">
        <strong>Address:</strong>
        <p>{clinicAddress}</p>
      </div>
      <div className="clinic-phone">
        <strong>Phone:</strong> {clinicPhone}
      </div>
      <div className="clinic-hours">
        <strong>Hours:</strong>
        <ul>
          {clinicHours.map((hour, index) => (
            <li key={index}>{hour}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

// PropTypes for LocationsComponent
LocationsComponent.propTypes = {
  location: PropTypes.string.isRequired,
  clinicName: PropTypes.string.isRequired,
  clinicAddress: PropTypes.string.isRequired,
  clinicPhone: PropTypes.string.isRequired,
  clinicHours: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default LocationsComponent;
